<div id="TransactionReportPopup" class="modal fade modal-scroll" tabindex="-1" data-replace="true" data-modal-index="1">
  <div class="modal-dialog modal-lg Transactionreport ">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{'TransactionReport' | translate}}</h4>
        <button type="button" class="close" data-toggle="modal" data-dismiss="modal" aria-hidden="true"> x </button>
      </div>
      <div class="modal-body Tmodal-body">
        <ng-container *ngIf="constant.IsVerified">
          <div class="site-wrapper">

            <div class="market-history">
              <div class="container">
                <div class="row">
                  <div class="col-12 col-sm-6 col-lg-3 no-position p-0">
                    <div class="form-group">
                      <label>{{ 'GameType' | translate }}</label>
                      <select class="form-control" [(ngModel)]="SelectedGameType" (ngModelChange)="ChangeEvent($event)">
                        <option [selected]="SelectedGameType=='Live'" value="Live">{{ 'Live' | translate }}</option>
                        <option [selected]="SelectedGameType=='Virtual'" value="Virtual">{{ 'RNG' | translate }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-lg-3 no-position p-0">
                    <div class="form-group">
                      <label>{{ 'Game' | translate }}</label>
                      <select class="form-control" [(ngModel)]="SelectedGame">
                        <option value="0">{{ 'All' | translate }}</option>
                        <option *ngFor="let item of TempGameList" value="{{item.GameCode.trim()}}">
                          {{item.GameCode?translateService.instant(item.GameCode.trim()) : item.Name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6 col-lg-2 no-position p-0">
                    <div class="form-group">
                      <label>{{ 'From' | translate }}</label>
                      <input type="date" class="form-control" [max]="MaxDate" [(ngModel)]="StartDate">
                    </div>
                  </div>
                  <div class="col-6 col-lg-2 no-position p-0">
                    <div class="form-group">
                      <label>{{ 'To' | translate }}</label>
                      <input type="date" class="form-control" [max]="MaxDate" [(ngModel)]="EndDate">
                    </div>
                  </div>

                  <div class="col-12 col-lg-2 no-position p-0">
                    <br>
                    <button type="button" class="btn btn-primary btn-search  w-100" (click)="SearchMarketHistory()"
                      style="box-shadow: none;">{{ 'Search' | translate }} </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 overflow-auto p-0" style="max-height: 300px;max-height: calc(100vh - 335px);">
                    <table class="table table-bordered table-betview noMarginBottom market-history-table">
                      <thead class="sticky-header">
                        <tr class="clsBackTr" style="color:white;background-color: rgb(3 10 22);">
                          <th class="col-2 text-center">{{ 'RefID' | translate }}</th>
                          <th class="col-2 text-center">{{ 'Date' | translate }}</th>
                          <th class="col-6 text-center">{{ 'Description' | translate }} </th>
                          <th class="col-1 text-center">{{ 'Dr' | translate }} </th>
                          <th class="col-1 text-center">{{ 'Cr' | translate }} </th>
                          <!-- <th class="col-md-1 col-sm-1 col-xs-1 text-center">Video</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of MarketHistoryList" class="color-black">
                          <td class="col-2 text-center">
                            <span>{{item.RoundSummaryID}}</span>
                          </td>
                          <td class="col-2 text-center">
                            <span>{{constant.utcToLocal(item.CreatedDate) | date : 'dd-MM-yyyy hh:mm a'}}</span>
                          </td>
                          <td class="col-6 text-center">
                            <a href="#GhistoryPopup" data-toggle="modal" (click)="GetMarketHistoryDetails(item)">
                              {{GameDescription(item)}}
                            </a>
                          </td>
                          <td class="col-1 text-right">
                            <span>{{item.Dr | number:'1.2-2'}}</span>
                          </td>
                          <td class="col-1 text-right">
                            <span>{{item.Cr | number:'1.2-2'}}</span>
                          </td>
                          <!-- <td class="text-center ">
                  <a href="#VideoPopup" class="dft-clr" data-toggle="modal">
                    <i class="fa fa-video-camera"></i>
                  </a>
                </td> -->
                          <!-- Balance : <span><{{item.Balance | number:'1.2-2'}}></span> -->
                        </tr>
                        <tr *ngIf="MarketHistoryList.length==0">
                          <td colspan="6" class="text-center">{{ 'NoRecordFound' | translate }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-sm-12 p-0">
                    <div class="float-end" style="margin-top: 15px;">
                      <ngb-pagination [collectionSize]="rowCount" [(page)]="currentPage" [pageSize]="perPageData"
                        [maxSize]="3" [rotate]="true" [ellipses]="true" [boundaryLinks]="true"
                        (pageChange)="setPage($event)">
                      </ngb-pagination>
                    </div>
                    <div class="me-1 float-start" style="margin-top: 15px;">
                      <select class="pagination" style="padding: 6px;padding: 6px;background: #07142c;color: white;border-color:black;" [(ngModel)]="perPageData"
                        (change)="GetMarketHistory()">
                        <option value="50" selected>50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </ng-container>
        <ng-container *ngIf="!constant.IsVerified">
          <p>{{'Invalid Token. Please Login Again' | translate}}</p>
        </ng-container>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>
<!-- Market History Details Pop Up Start -->
<div id="GhistoryPopup" class="modal fade modal-scroll ghistoryResult" tabindex="1" data-replace="true"
  data-modal-index="2">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header p-md-1">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
          x
        </button>
        <h4 class="modal-title markettitle" [hidden]="PopupLoader === true">
          {{TitleName(MarketHistoryDetails)}}</h4>
        <h4 class="modal-title markettitle" [hidden]="PopupLoader !== true">{{'Loading' | translate}}...</h4>
      </div>
      <div class="modal-body" [hidden]="PopupLoader === true">
        <!-- 1. Teen Patti Cards Start -->
        <div class="player-cards"
          [hidden]="selectedGameCode != 'TP' && selectedGameCode != 'TP20'  && selectedGameCode != 'VTP'  && selectedGameCode != 'VTP20' && selectedGameCode != 'TP7M'  && selectedGameCode != 'TPFO' && selectedGameCode != 'MTP7M' ">
          <div class="playera text-center" style="text-align: center;">
            <h6>{{ 'PlayerA' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player A'">
              {{ 'Winner' | translate }}
              {{MarketHistoryDetails.WinningHand ? '( ' +translateService.instant(MarketHistoryDetails.WinningHand)+' )' : ''}}
            </div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player B'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center" style="text-align: center;">
            <h6>{{ 'PlayerB' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player B'">
              {{ 'Winner' | translate }}
              <span *ngIf="MarketHistoryDetails.WinningHand">{{MarketHistoryDetails.WinningHand ? '( ' +translateService.instant(MarketHistoryDetails.WinningHand)+' )' : ''}}</span>
            </div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player A'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Draw'">
            <br>{{ 'Draw' | translate }}
          </div>
        </div>
        <!-- Teen Patti Cards End -->
        <!-- 2. Baccarat Cards Start -->
        <div class="player-cards"
          [hidden]="selectedGameCode != 'BAC' && selectedGameCode != 'BAC20' && selectedGameCode != 'VBAC' && selectedGameCode != 'VBAC20'">
          <div class="playera text-center">
            <h6>{{ 'Player' | translate }} <span class="score"
                [ngClass]="MarketHistoryDetails.PlayerAScore>MarketHistoryDetails.PlayerBScore?'green':'red'">{{MarketHistoryDetails.PlayerAScore}}</span>
            </h6>
            <div class="mhistorycard flipcard h rotate">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[2]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Banker'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center">
            <h6>{{ 'Banker' | translate }} <span class="score"
                [ngClass]="MarketHistoryDetails.PlayerBScore>MarketHistoryDetails.PlayerAScore?'green':'red'">{{MarketHistoryDetails.PlayerBScore}}</span>
            </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h rotate-reverse">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Banker'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Tie'">
            <br>{{ 'Tie' | translate }}
          </div>
        </div>
        <!-- Baccarat Cards End -->

        <!-- 3. Dragon Tiger Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'DT' && selectedGameCode != 'DT7M'">
          <div class="playera text-center" style="text-align: center;">
            <h6>{{ 'Dragon' | translate }} </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Dragon'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Tiger'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center" style="text-align: center;">
            <h6>{{ 'Tiger' | translate }} </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Tiger'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Dragon'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Tie'">
            <br>{{ 'Tie' | translate }}
          </div>
          <div class="game-result  winner-hand">
            {{ 'Dragon' | translate }} : {{MarketHistoryDetails.winHand.DragonSuite? translateService.instant(MarketHistoryDetails.winHand.DragonSuite) : ''}} |
            {{MarketHistoryDetails.winHand.Dragon? translateService.instant(MarketHistoryDetails.winHand.Dragon) : ''}}
          </div>
          <div class="game-result  winner-hand">
            {{ 'Tiger' | translate }} : {{MarketHistoryDetails.winHand.TigerSuite? translateService.instant(MarketHistoryDetails.winHand.TigerSuite) : ''}} |
            {{MarketHistoryDetails.winHand.Tiger? translateService.instant(MarketHistoryDetails.winHand.Tiger) : ''}}
          </div>
        </div>
        <!-- Dragon Tiger Cards End -->

        <!-- 13. Dragon Tiger 20-20 Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'DT20'">
          <div class="playera text-center" style="text-align: center;">
            <h6>{{ 'Dragon' | translate }} </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Dragon'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Tiger'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center" style="text-align: center;">
            <h6>{{ 'Tiger' | translate }} </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Tiger'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Dragon'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Tie'">
            <br>{{ 'Tie' | translate }}
          </div>
          <div class="game-result  winner-hand">
            {{ 'Dragon' | translate }} :
            <span
              *ngIf="MarketHistoryDetails.winHand.DragonSuite &&  MarketHistoryDetails.winHand.Dragon">{{MarketHistoryDetails.winHand.DragonSuite? translateService.instant(MarketHistoryDetails.winHand.DragonSuite) : ''}}|
              {{MarketHistoryDetails.winHand.Dragon? translateService.instant(MarketHistoryDetails.winHand.Dragon) : ''}}</span>
          </div>
          <div class="game-result winner-hand">
            {{ 'Tiger' | translate }} :
            <span
              *ngIf="MarketHistoryDetails.winHand.TigerSuite &&  MarketHistoryDetails.winHand.Tiger">{{MarketHistoryDetails.winHand.TigerSuite? translateService.instant(MarketHistoryDetails.winHand.TigerSuite) : ''}}|
              {{MarketHistoryDetails.winHand.Tiger? translateService.instant(MarketHistoryDetails.winHand.Tiger) : ''}}</span>
            <!-- {{MarketHistoryDetails.winHand.TigerSuite? translateService.instant(MarketHistoryDetails.winHand.TigerSuite) : ''}} |
            {{MarketHistoryDetails.winHand.Tiger? translateService.instant(MarketHistoryDetails.winHand.Tiger) : ''}} -->

          </div>
        </div>
        <!-- Dragon Tiger 20-20 Cards End -->

        <!-- 4. Poker Cards Start -->
        <div class="player-cards poker row" [hidden]="selectedGameCode != 'PK'">
          <div class="poker-card-block">

            <div class="col-6 text-center float-left">
              <h6>{{ 'Flop' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[1]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[2]]}}">
                </div>
              </div>
            </div>

            <div class="col-6 text-center float-left">
              <div class="col-6 text-center float-left">
                <h6>{{ 'Turn' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[3]]}}">
                  </div>
                </div>
              </div>

              <div class="col-6 text-center float-left">
                <h6>{{ 'River' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[4]]}}">
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 text-center float-left">
              <h6 class="margin-top">{{ 'PlayerA' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player A'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player B'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="col-6 text-center float-left">
              <h6 class="margin-top">{{ 'PlayerB' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player B'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player A'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="col-12 text-center float-left">
              <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Split Pot!'">
                <br>{{ 'Draw' | translate }}
              </div>
            </div>

          </div>
        </div>
        <!-- Poker Cards End -->

        <!-- 5. Andar Bahar Cards Start -->
        <div class="player-cards andar-bahar" [hidden]="selectedGameCode != 'AB' && selectedGameCode != 'AB20' ">
          <div class="player-cont row" style="justify-content: center;">
            <div class="player-cont playera text-center col-sm-4">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[MarketHistoryDetails.PlayerACard.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Andar' | translate }}</h6>
              <!-- <div class="badge right">{{ 'A' | translate }}</div> -->
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Andar'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Bahar'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class="player-cont playera text-center col-sm-4">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerTCard[0]]}}">
                </div>
              </div>
              <h6>{{ 'Joker' | translate }}</h6>
            </div>

            <div class="player-cont playera text-center col-sm-4">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[MarketHistoryDetails.PlayerBCard.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Bahar' | translate }}</h6>
              <!-- <div class="badge left">{{ 'B' | translate }}</div> -->
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Bahar'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Andar'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Draw'">
              <br>{{ 'Draw' | translate }}
            </div>
          </div>
          <div class="game-result winner-hand" *ngIf="abWinnerHand.Hand">
            {{ 'Hand' | translate }} : {{abWinnerHand.Hand? translateService.instant(abWinnerHand.Hand) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="abWinnerHand.JokerSuite">
            {{ 'JokerSuite' | translate }} : {{abWinnerHand.JokerSuite? translateService.instant(abWinnerHand.JokerSuite) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="abWinnerHand.WinnerSuite">
            {{ 'WinningSuite' | translate }} : {{abWinnerHand.WinnerSuite? translateService.instant(abWinnerHand.WinnerSuite) : ''}}
          </div>
        </div>
        <!-- Andar Bahar Cards End -->
        <!-- 5. Andar Bahar 2.0 Cards Start -->
        <div class="player-cards andar-bahar" [hidden]="selectedGameCode != 'AB2' && selectedGameCode != 'ABC'">
          <div class="player-cont row" style="justify-content: center;">
            <div class="player-cont playera text-center col-sm-4">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[MarketHistoryDetails.PlayerACard.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Andar' | translate }}</h6>
              <!-- <div class="badge right">{{ 'A' | translate }}</div> -->
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Andar'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Bahar'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class="player-cont playera text-center col-sm-4">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerTCard[0]]}}">
                </div>
              </div>
              <h6>{{ 'Joker' | translate }}</h6>
            </div>

            <div class="player-cont playera text-center col-sm-4">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[MarketHistoryDetails.PlayerBCard.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Bahar' | translate }}</h6>
              <!-- <div class="badge left">{{ 'B' | translate }}</div> -->
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Bahar'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Andar'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Draw'">
              <br>{{ 'Draw' | translate }}
            </div>
          </div>
          <div class="game-result winner-hand" *ngIf="abWinnerHand.WinnerSuite">
            {{ 'WinningSuite' | translate }} :
            <span *ngIf="abWinnerHand.WinnerSuite">({{abWinnerHand.WinnerSuite? translateService.instant(abWinnerHand.WinnerSuite) : ''}})</span>
          </div>
        </div>
        <!-- Andar Bahar 2.0 Cards End -->

        <!-- Worli Matka Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'WM'">
          <div class="playera text-center" style="text-align: center;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[2]]}}"> </div>
            </div>
          </div>
          <div class="game-result win"><br>{{ 'Winner' | translate }} {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}
            {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}} </div>
        </div>
        <!-- Worli Matka Cards End -->

        <!-- 7. Akbar Romeo Walter Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'ARW'">
          <div class="playera text-center" style="text-align: center;float: none;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
          </div>
          <div class="game-result draw"><br>{{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}</div>
          <div class="game-result winner-hand " *ngIf="ARWWinningHand.Hand">
            {{ 'Hand' | translate }} : {{ARWWinningHand.Hand ? translateService.instant(ARWWinningHand.Hand) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="ARWWinningHand.Suite">
            {{ 'Suite' | translate }} : {{ARWWinningHand.Suite? translateService.instant(ARWWinningHand.Suite) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="ARWWinningHand.Seven">
            {{ARWWinningHand.Seven? translateService.instant(ARWWinningHand.Seven) : ''}}
          </div>
        </div>
        <!-- Akbar Romeo Walter Cards End -->

        <!-- 9. Poker 20-20 Cards Start -->
        <div class="player-cards poker row" [hidden]="selectedGameCode != 'PK20'">
          <div class="poker-card-block">

            <div class="col-6 text-center float-left">
              <h6>{{ 'Flop' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[1]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[2]]}}">
                </div>
              </div>
            </div>

            <div class="col-6 text-center float-left">
              <div class="col-6 text-center float-left">
                <h6>{{ 'Turn' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[3]]}}">
                  </div>
                </div>
              </div>

              <div class="col-6 text-center float-left">
                <h6>{{ 'River' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[4]]}}">
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 text-center float-left">
              <h6 class="margin-top">{{ 'PlayerA' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player A'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player B'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="col-6 text-center float-left">
              <h6 class="margin-top">{{ 'PlayerB' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player B'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player A'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="col-12 text-center float-left">
              <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Split Pot!'">
                <br>{{ 'Draw' | translate }}
              </div>
            </div>

          </div>
        </div>
        <!-- Poker 20-20 Cards End -->

        <!-- 10. 32 Cards Cards Start -->
        <div class="player-cards andar-bahar" [hidden]="selectedGameCode != 'C32'">
          <div class="player-cont row" style="justify-content: center;">
            <div class="player-cont playera text-center col-sm-3">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails?.Card?.Player8?.Cards[MarketHistoryDetails?.Card?.Player8?.Cards?.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Player8' | translate }}</h6>
              <div class="badge right">{{MarketHistoryDetails?.Card?.Player8?.Score}}</div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player 8'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player 8'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="player-cont playera text-center col-sm-3">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails?.Card?.Player9?.Cards[MarketHistoryDetails?.Card?.Player9?.Cards?.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Player9' | translate }}</h6>
              <div class="badge right">{{MarketHistoryDetails?.Card?.Player9?.Score}}</div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player 9'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player 9'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="player-cont playera text-center col-sm-3">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails?.Card?.Player10?.Cards[MarketHistoryDetails?.Card?.Player10?.Cards?.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Player10' | translate }}</h6>
              <div class="badge right">{{MarketHistoryDetails?.Card?.Player10?.Score}}</div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player 10'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player 10'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="player-cont playera text-center col-sm-3">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails?.Card?.Player11?.Cards[MarketHistoryDetails?.Card?.Player11?.Cards?.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Player11' | translate }}</h6>
              <div class="badge right">{{MarketHistoryDetails?.Card?.Player11?.Score}}</div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player 11'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player 11'">
                {{ 'Loser' | translate }}</div>
            </div>
          </div>
        </div>
        <!-- 32 Cards Cards End -->

        <!-- 11. 7Up 7Down Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'UD7'">
          <div class="playera text-center" style="text-align: center;float: none;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
          </div>
          <div class="game-result draw"><br>{{ 'Winner' | translate }} {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}</div>
          <div class="game-result winner-hand">
            {{MarketHistoryDetails.WinningHand ? translateService.instant(MarketHistoryDetails.WinningHand) : ''}}
          </div>
        </div>
        <!-- 7Up 7Down Cards End -->

        <!-- 12. Poker 6 Player Cards Start -->
        <div class="player-cards poker row" [hidden]="selectedGameCode != 'PK6'">
          <div class="poker-card-block">

            <div class="player-cont playera text-center w-50" style="width: 50% !important;">
              <h6>{{ 'Flop' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[1]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[2]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont w-50" style="width: 50% !important;">
              <div class="player-cont playera text-center w-50">
                <h6>{{ 'Turn' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[3]]}}">
                  </div>
                </div>
              </div>

              <div class="player-cont playera text-center w-50">
                <h6>{{ 'River' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[4]]}}">
                  </div>
                </div>
              </div>
            </div>

            <div class="player-cont playera text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player1' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player1Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player1Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playerb text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player2' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player2Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player2Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playera text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player3' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player3Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player3Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playerb text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player4' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player4Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player4Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playera text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player5' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player5Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player5Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playerb text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player6' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player6Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player6Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont w-100" style="width: 100%;">
              <div class="game-result win"><br>{{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
            </div>

          </div>
        </div>
        <!-- Poker 6 Player Cards End -->

        <!-- 14. Poker 6 Player 20-20 Cards Start -->
        <div class="player-cards poker row" [hidden]="selectedGameCode != 'PK620'">
          <div class="poker-card-block">

            <div class="player-cont playera text-center w-50" style="width: 50% !important;">
              <h6>{{ 'Flop' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[1]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[2]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont w-50" style="width: 50% !important;">
              <div class="player-cont playera text-center w-50">
                <h6>{{ 'Turn' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[3]]}}">
                  </div>
                </div>
              </div>

              <div class="player-cont playera text-center w-50">
                <h6>{{ 'River' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[4]]}}">
                  </div>
                </div>
              </div>
            </div>

            <div class="player-cont playera text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player1' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player1Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player1Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playerb text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player2' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player2Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player2Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playera text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player3' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player3Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player3Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playerb text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player4' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player4Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player4Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playera text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player5' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player5Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player5Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont playerb text-center w-33" style="margin-bottom: 0;">
              <h6>{{ 'Player6' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player6Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player6Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="player-cont w-100" style="width: 100%;">
              <div class="game-result win"><br>{{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
            </div>

          </div>
        </div>
        <!-- Poker 6 Player 20-20 Cards End -->

        <!-- Virtual Dragon Tiger Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'VDT'">
          <div class="playera text-center" style="text-align: center;">
            <h6>{{ 'Dragon' | translate }} </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Dragon'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Tiger'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center" style="text-align: center;">
            <h6>{{ 'Tiger' | translate }} </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Tiger'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Dragon'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Tie'">
            <br>{{ 'Tie' | translate }}
          </div>
          <div class="game-result  winner-hand">
            {{ 'Dragon' | translate }} : {{MarketHistoryDetails.winHand.DragonSuite? translateService.instant(MarketHistoryDetails.winHand.DragonSuite) : ''}} |
            {{MarketHistoryDetails.winHand.Dragon? translateService.instant(MarketHistoryDetails.winHand.Dragon) : ''}}
          </div>
          <div class="game-result winner-hand">
            {{ 'Tiger' | translate }} : {{MarketHistoryDetails.winHand.TigerSuite? translateService.instant(MarketHistoryDetails.winHand.TigerSuite) : ''}} |
            {{MarketHistoryDetails.winHand.Tiger? translateService.instant(MarketHistoryDetails.winHand.Tiger) : ''}}
          </div>
        </div>
        <!-- Virtual Dragon Tiger Cards End -->
        <!-- Virtual 7Up 7Down Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'VUD7'">
          <div class="playera text-center" style="text-align: center;float: none;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
          </div>
          <div class="game-result draw"><br>{{ 'Winner' | translate }} {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}</div>
          <div class="game-result winner-hand">
            {{MarketHistoryDetails.WinningHand ? translateService.instant(MarketHistoryDetails.WinningHand) : ''}}
          </div>
        </div>
        <!-- Virtual 7Up 7Down Cards End -->
        <!-- Virtual Poker Cards Start -->
        <div class="player-cards poker row" [hidden]="selectedGameCode != 'VPK' && selectedGameCode != 'VPK20'">
          <div class="poker-card-block">

            <div class="col-6 text-center float-left">
              <h6>{{ 'Flop' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[1]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[2]]}}">
                </div>
              </div>
            </div>

            <div class="col-6 text-center float-left">
              <div class="col-6 text-center float-left">
                <h6>{{ 'Turn' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[3]]}}">
                  </div>
                </div>
              </div>

              <div class="col-6 text-center float-left">
                <h6>{{ 'River' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[4]]}}">
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 text-center float-left">
              <h6 class="margin-top">{{ 'PlayerA' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player A'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player B'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="col-6 text-center float-left">
              <h6 class="margin-top">{{ 'PlayerB' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player B'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player A'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="col-12 text-center float-left">
              <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Split Pot!'">
                <br>{{ 'Draw' | translate }}
              </div>
            </div>

          </div>
        </div>
        <!-- Virtual Poker Cards End -->
        <!-- Virtual Worli Matka Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'VWM'">
          <div class="playera text-center" style="text-align: center;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[2]]}}"> </div>
            </div>
          </div>
          <div class="game-result win"><br>{{ 'Winner' | translate }} {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}
            {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}} </div>
        </div>
        <!-- Virtual Worli Matka Cards End -->
        <!-- Virtual 32 Cards Cards Start -->
        <div class="player-cards andar-bahar" [hidden]="selectedGameCode != 'VC32'">
          <div class="player-cont row" style="justify-content: center;">
            <div class="player-cont playera text-center col-sm-3">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails?.Card?.Player8?.Cards[MarketHistoryDetails?.Card?.Player8?.Cards?.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Player8' | translate }}</h6>
              <div class="badge right">{{MarketHistoryDetails?.Card?.Player8?.Score}}</div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player 8'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player 8'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="player-cont playera text-center col-sm-3">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails?.Card?.Player9?.Cards[MarketHistoryDetails?.Card?.Player9?.Cards?.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Player9' | translate }}</h6>
              <div class="badge right">{{MarketHistoryDetails?.Card?.Player9?.Score}}</div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player 9'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player 9'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="player-cont playera text-center col-sm-3">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails?.Card?.Player10?.Cards[MarketHistoryDetails?.Card?.Player10?.Cards?.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Player10' | translate }}</h6>
              <div class="badge right">{{MarketHistoryDetails?.Card?.Player10?.Score}}</div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player 10'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player 10'">
                {{ 'Loser' | translate }}</div>
            </div>

            <div class="player-cont playera text-center col-sm-3">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails?.Card?.Player11?.Cards[MarketHistoryDetails?.Card?.Player11?.Cards?.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Player11' | translate }}</h6>
              <div class="badge right">{{MarketHistoryDetails?.Card?.Player11?.Score}}</div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player 11'">
                {{ 'Winner' | translate }}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player 11'">
                {{ 'Loser' | translate }}</div>
            </div>
          </div>
        </div>
        <!-- Virtual 32 Cards Cards End -->
        <!-- Virtual Andar Bahar Cards Start -->
        <div class="player-cards andar-bahar" [hidden]="selectedGameCode != 'VAB20'">
          <div class="player-cont row" style="justify-content: center;">
            <div class="player-cont playera text-center col-sm-4">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[MarketHistoryDetails.PlayerACard.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Andar' | translate }}</h6>
              <!-- <div class="badge right">{{ 'A' | translate }}</div> -->
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Andar'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Bahar'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class="player-cont playera text-center col-sm-4">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerTCard[0]]}}">
                </div>
              </div>
              <h6>{{ 'Joker' | translate }}</h6>
            </div>

            <div class="player-cont playera text-center col-sm-4">
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[MarketHistoryDetails.PlayerBCard.length - 1]]}}">
                </div>
              </div>
              <h6>{{ 'Bahar' | translate }}</h6>
              <!-- <div class="badge left">{{ 'B' | translate }}</div> -->
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Bahar'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Andar'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Draw'">
              <br>{{ 'Draw' | translate }}
            </div>
          </div>
          <div class="game-result winner-hand" *ngIf="abWinnerHand.Hand">
            {{ 'Hand' | translate }} : {{abWinnerHand.Hand? translateService.instant(abWinnerHand.Hand) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="abWinnerHand.JokerSuite">
            {{ 'JokerSuite' | translate }} : {{abWinnerHand.JokerSuite? translateService.instant(abWinnerHand.JokerSuite) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="abWinnerHand.WinnerSuite">
            {{ 'WinningSuite' | translate }} : {{abWinnerHand.WinnerSuite? translateService.instant(abWinnerHand.WinnerSuite) : ''}}
          </div>
        </div>
        <!-- Virtual Andar Bahar Cards End -->
        <!-- Virtual Akbar Romeo Walter Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'VARW'">
          <div class="playera text-center" style="text-align: center;float: none;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
          </div>
          <div class="game-result draw"><br>{{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}</div>
          <div class="game-result winner-hand " *ngIf="ARWWinningHand.Hand">
            {{ 'Hand' | translate }} : {{ARWWinningHand.Hand ? translateService.instant(ARWWinningHand.Hand) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="ARWWinningHand.Suite">
            {{ 'Suite' | translate }} : {{ARWWinningHand.Suite? translateService.instant(ARWWinningHand.Suite) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="ARWWinningHand.Seven">
            {{ARWWinningHand.Seven? translateService.instant(ARWWinningHand.Seven) : ''}}
          </div>
        </div>
        <!-- Virtual Akbar Romeo Walter Cards End -->
        <!-- Virtual Dragon Tiger Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'VDT20'">
          <div class="playera text-center" style="text-align: center;">
            <h6>{{ 'Dragon' | translate }} </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Dragon'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Tiger'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center" style="text-align: center;">
            <h6>{{ 'Tiger' | translate }} </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Tiger'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Dragon'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Tie'">
            <br>{{ 'Tie' | translate }}
          </div>
          <div class="game-result  winner-hand">
            {{ 'Dragon' | translate }} : {{MarketHistoryDetails.winHand.DragonSuite? translateService.instant(MarketHistoryDetails.winHand.DragonSuite) : ''}} |
            {{MarketHistoryDetails.winHand.Dragon? translateService.instant(MarketHistoryDetails.winHand.Dragon) : ''}}
          </div>
          <div class="game-result winner-hand">
            {{ 'Tiger' | translate }} : {{MarketHistoryDetails.winHand.TigerSuite? translateService.instant(MarketHistoryDetails.winHand.TigerSuite) : ''}} |
            {{MarketHistoryDetails.winHand.Tiger? translateService.instant(MarketHistoryDetails.winHand.Tiger) : ''}}
          </div>
        </div>
        <!-- Virtual Dragon Tiger Cards End -->

        <!-- Virtual 3 Cards Judgement Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'V3CJ'">
          <div class="playera text-center" style="text-align: center;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[2]]}}"> </div>
            </div>
          </div>
          <div class="game-result win"><br>{{ 'Winner' | translate }} {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}
            {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}} </div>
        </div>
        <!-- Virtual 3 Cards Judgement Cards End -->
        <!-- Virtual 3 Player Teen Patti Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'V3TP' ">
          <div class="playera text-center" style="text-align: center;">
            <h6>{{ 'PlayerA' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player A'">
              {{ 'Winner' | translate }}
              {{MarketHistoryDetails.WinningHand ? '( ' +translateService.instant(MarketHistoryDetails.WinningHand)+' )' : ''}}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player A'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center" style="text-align: center;">
            <h6>{{ 'PlayerB' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player B'">
              {{ 'Winner' | translate }}
              {{MarketHistoryDetails.WinningHand ? '( ' +translateService.instant(MarketHistoryDetails.WinningHand)+' )' : ''}}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player B'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playera text-center" style="text-align: center;">
            <h6>{{ 'PlayerC' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerCCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerCCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerCCard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player C'">
              {{ 'Winner' | translate }}
              {{MarketHistoryDetails.WinningHand ? '( ' +translateService.instant(MarketHistoryDetails.WinningHand)+' )' : ''}}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player C'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Draw'">
            <br>{{ 'Draw' | translate }}
          </div>
        </div>
        <!--  Virtual Teen Patti Cards End -->
        <!-- Virtual  Black Jack Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'VBJ' && selectedGameCode != 'BJ'">
          <div class="black-jack-card" style="margin: auto; width: 200px;">
            <div class=" text-center" style="width: 100px;float: left;">
              <h6>{{ 'PlayerA' | translate }}<span class="score"
                  [ngClass]="MarketHistoryDetails.PlayerAScore>MarketHistoryDetails.PlayerEScore?'green':'red'">{{MarketHistoryDetails.PlayerAScore}}</span>
              </h6>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[MarketHistoryDetails.PlayerACard.length - 3]]}}">
                </div>
              </div>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[MarketHistoryDetails.PlayerACard.length - 2]]}}">
                </div>
              </div>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[MarketHistoryDetails.PlayerACard.length - 1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='PlayerA'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner != 'PlayerA'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class=" text-center" style="width: 100px;float: left;">
              <h6>{{ 'PlayerB' | translate }}<span class="score"
                  [ngClass]="MarketHistoryDetails.PlayerBScore>MarketHistoryDetails.PlayerEScore?'green':'red'">{{MarketHistoryDetails.PlayerBScore}}</span>
              </h6>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[MarketHistoryDetails.PlayerBCard.length - 3]]}}">
                </div>
              </div>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[MarketHistoryDetails.PlayerBCard.length - 2]]}}">
                </div>
              </div>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[MarketHistoryDetails.PlayerBCard.length - 1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='PlayerB'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner != 'PlayerB'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class=" text-center" style="width: 100px;float: left;">
              <h6>{{ 'PlayerC' | translate }}<span class="score"
                  [ngClass]="MarketHistoryDetails.PlayerCScore>MarketHistoryDetails.PlayerEScore?'green':'red'">{{MarketHistoryDetails.PlayerCScore}}</span>
              </h6>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerCCard[MarketHistoryDetails.PlayerCCard.length - 3]]}}">
                </div>
              </div>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerCCard[MarketHistoryDetails.PlayerCCard.length - 2]]}}">
                </div>
              </div>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerCCard[MarketHistoryDetails.PlayerCCard.length - 1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='PlayerC'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner != 'PlayerC'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class=" text-center" style="width: 100px;float: left;">
              <h6>{{ 'PlayerD' | translate }}<span class="score"
                  [ngClass]="MarketHistoryDetails.PlayerDScore>MarketHistoryDetails.PlayerEScore?'green':'red'">{{MarketHistoryDetails.PlayerDScore}}</span>
              </h6>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerDCard[MarketHistoryDetails.PlayerDCard.length - 3]]}}">
                </div>
              </div>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerDCard[MarketHistoryDetails.PlayerDCard.length - 2]]}}">
                </div>
              </div>
              <div class="historycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerDCard[MarketHistoryDetails.PlayerDCard.length - 1]]}}">
                </div>
              </div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='PlayerD'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner != 'PlayerD'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class="text-center" style="width: 100px;margin: auto;">
              <h6>{{ 'Dealer' | translate }} <span class="score"
                  [ngClass]="(MarketHistoryDetails.PlayerEScore>MarketHistoryDetails.PlayerAScore && MarketHistoryDetails.PlayerEScore>MarketHistoryDetails.PlayerBScore &&
                      MarketHistoryDetails.PlayerEScore>MarketHistoryDetails.PlayerCScore && MarketHistoryDetails.PlayerEScore>MarketHistoryDetails.PlayerDScore)?'green':'red'">
                  {{MarketHistoryDetails.PlayerEScore}}
                </span>
              </h6>
              <div class="mhistorycard flipcard h ">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[MarketHistoryDetails.PlayerBCard.length - 3]]}}">
                </div>
              </div>
              <div class="mhistorycard flipcard h ">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[MarketHistoryDetails.PlayerBCard.length - 2]]}}">
                </div>
              </div>
              <div class="mhistorycard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[MarketHistoryDetails.PlayerBCard.length - 1]]}}">
                </div>
              </div>

              <!-- <div class="historycard flipcard h">
          <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
          <div class="back"><img class="casinocard"
              src="{{constant.CardImages[GameHistoryDetails.PlayerECard[GameHistoryDetails.PlayerECard.length - 1]]}}">
          </div>
        </div> -->
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Dealer'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner != 'Dealer'">
                {{ 'Loser' | translate }}</div>
            </div>
            <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Tie'">
              <br>{{ 'Tie' | translate }}
            </div>
          </div>
        </div>
        <!-- Virtual Black Jack Cards End -->
        <!-- Virtual 3 Cards Judgement Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'D3CJ'">
          <div class="playera text-center" style="text-align: center;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[2]]}}"> </div>
            </div>
          </div>
          <div class="game-result win"><br>{{ 'Winner' | translate }} {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}
            {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}} </div>
        </div>
        <!-- Virtual 3 Cards Judgement Cards End -->
        <!-- Virtual 3 Player Teen Patti Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'D3TP' ">
          <div class="playera text-center" style="text-align: center;">
            <h6>{{ 'PlayerA' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player A'">
              {{ 'Winner' | translate }}
              {{MarketHistoryDetails.WinningHand ? '( ' +translateService.instant(MarketHistoryDetails.WinningHand)+' )' : ''}}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player A'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center" style="text-align: center;">
            <h6>{{ 'PlayerB' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player B'">
              {{ 'Winner' | translate }}
              {{MarketHistoryDetails.WinningHand ? '( ' +translateService.instant(MarketHistoryDetails.WinningHand)+' )' : ''}}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player B'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playera text-center" style="text-align: center;">
            <h6>{{ 'PlayerC' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerCCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerCCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerCCard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player C'">
              {{ 'Winner' | translate }}
              {{MarketHistoryDetails.WinningHand ? '( ' +translateService.instant(MarketHistoryDetails.WinningHand)+' )' : ''}}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Player C'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Draw'">
            <br>{{ 'Draw' | translate }}
          </div>
        </div>
        <!--  Virtual Teen Patti Cards End -->
        <!-- Virtual  Black Jack Cards Start -->
        <div class="player-cards"
          [hidden]="selectedGameCode != 'VBJC' && selectedGameCode != 'BJC' && selectedGameCode != 'IBJ'">
          <div class="playera text-center">
            <h6>{{ 'Player' | translate }} <span class="score"
                [ngClass]="MarketHistoryDetails.PlayerScore>MarketHistoryDetails.DealerScore?'green':'red'">{{MarketHistoryDetails.PlayerScore}}</span>
            </h6>
            <div class="mhistorycard flipcard h">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerCard[2]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerCard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Dealer'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center">
            <h6>{{ 'Dealer' | translate }} <span class="score"
                [ngClass]="MarketHistoryDetails.DealerScore>MarketHistoryDetails.PlayerScore?'green':'red'">{{MarketHistoryDetails.DealerScore}}</span>
            </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DealerCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DealerCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DealerCard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Dealer'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Tie'">
            <br>{{ 'Tie' | translate }}
          </div>
        </div>
        <!-- Virtual Black Jack Cards End -->
        <!-- Virtual Poker 6 Player and 20-20 Cards Start -->
        <div class="player-cards poker row" [hidden]="selectedGameCode != 'VPK620' && selectedGameCode != 'VPK6'">
          <div class="poker-card-block">

            <div class="col-6 text-center col-6 text-center float-left">
              <h6>{{ 'Flop' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[1]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.TableCard[2]]}}">
                </div>
              </div>
            </div>

            <div class="col-6 text-center float-left">
              <div class="col-6 text-center float-left">
                <h6>{{ 'Turn' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[3]]}}">
                  </div>
                </div>
              </div>

              <div class="col-6 text-center float-left">
                <h6>{{ 'River' | translate }}</h6>
                <div class="livecard flipcard h">
                  <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                  <div class="back"><img class="casinocard"
                      src="{{constant.CardImages[MarketHistoryDetails.TableCard[4]]}}">
                  </div>
                </div>
              </div>
            </div>

            <div class="col-4 text-center float-left">
              <h6 class="margin-top">{{ 'Player1' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player1Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player1Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="col-4 text-center float-left">
              <h6 class="margin-top">{{ 'Player2' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player2Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player2Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="col-4 text-center float-left">
              <h6 class="margin-top">{{ 'Player3' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player3Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player3Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="col-4 text-center float-left">
              <h6 class="margin-top">{{ 'Player4' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player4Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player4Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="col-4 text-center float-left">
              <h6 class="margin-top">{{ 'Player5' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"> <img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player5Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player5Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="col-4 text-center float-left">
              <h6 class="margin-top">{{ 'Player6' | translate }}</h6>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player6Card[0]]}}">
                </div>
              </div>
              <div class="livecard flipcard h">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.Player6Card[1]]}}">
                </div>
              </div>
            </div>

            <div class="col-12 text-center float-left">
              <div class="game-result win"><br>{{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}
                {{MarketHistoryDetails.WinningHand ? ' (' + translateService.instant(MarketHistoryDetails.WinningHand) + ')' : ''}}
              </div>
            </div>
          </div>
        </div>
        <!-- Virtual Poker 6 Player and 20-20 Cards End -->
        <!-- 39. Live Joker Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'VJKR' && selectedGameCode != 'JKR'">
          <div class="playera text-center" style="text-align: center;float: none;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
          </div>
          <div class="game-result draw"><br>{{ 'Winner' | translate }} :
            {{JokerNumber(MarketHistoryDetails.Winner)}}</div>
          <div class="game-result winner-hand " *ngIf="JKRWinnerHand.Number">
            {{JKRWinnerHand.Number? translateService.instant(JKRWinnerHand.Number) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="JKRWinnerHand.Color">
            {{ 'Color' | translate }} : {{JKRWinnerHand.Color? translateService.instant(JKRWinnerHand.Color) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="JKRWinnerHand.CardSuit">
            {{ 'CardSuite' | translate }} : {{JKRWinnerHand.CardSuit? translateService.instant(JKRWinnerHand.CardSuit) : ''}}
          </div>
        </div>
        <!-- Liver Joker Cards End -->
        <!-- Kabutar Fuddi Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'KF' && selectedGameCode != 'VKF'">
          <div class="playera text-center" style="text-align: center;float: none;">
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back">
                <img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}">
              </div>
            </div>
          </div>
          <div class="game-result draw"><br>{{ 'Winner' | translate }} : {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}
          </div>
        </div>
        <!-- Live Kabutar Fuddi Cards End -->
        <!-- Virtual Card Race Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'VCR'">
          <div class="playera text-center card-race">
            <h6>{{ 'Spade' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[2]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[3]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[4]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[5]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Spade'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Spade'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="playerb text-center card-race">
            <h6>{{ 'Club' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[0]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[1]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[2]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[3]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[4]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[5]]}}">
              </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Club'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Club'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="playera text-center card-race">
            <h6>{{ 'Diamond' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[2]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[3]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[4]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[5]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Diamond'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Diamond'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="playerb text-center card-race">
            <h6>{{ 'Heart' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[2]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[3]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[4]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[5]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Heart'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Heart'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Draw'">
            <br>{{ 'Draw' | translate }}
          </div>
          <div class="game-result winner-hand " *ngIf="CardRaceWinninghand.Hand">
            {{ 'Hand' | translate }} : {{CardRaceWinninghand.Hand? translateService.instant(CardRaceWinninghand.Hand) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="CardRaceWinninghand.Color">
            {{ 'Color' | translate }} : {{CardRaceWinninghand.Color? translateService.instant(CardRaceWinninghand.Color) : ''}}
          </div>
        </div>
        <!--  Virtual Card Race Cards End -->
        <!-- Card Race Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'CR'">
          <div class="playera text-center card-race">
            <h6>{{ 'Spade' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[2]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[3]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[4]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.SpadeCard[5]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Spade'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Spade'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="playerb text-center card-race">
            <h6>{{ 'Club' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[0]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[1]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[2]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[3]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[4]]}}">
              </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard" src="{{constant.CardImages[MarketHistoryDetails.ClubCard[5]]}}">
              </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Club'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Club'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="playera text-center card-race">
            <h6>{{ 'Diamond' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[2]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[3]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[4]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.DiamondCard[5]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Diamond'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Diamond'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="playerb text-center card-race">
            <h6>{{ 'Heart' | translate }}</h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[2]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[3]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[4]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.HeartCard[5]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Heart'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner!='Heart'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Draw'">
            <br>{{ 'Draw' | translate }}
          </div>
          <div class="game-result winner-hand " *ngIf="CardRaceWinninghand.Hand">
            {{ 'Hand' | translate }} : {{CardRaceWinninghand.Hand? translateService.instant(CardRaceWinninghand.Hand) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="CardRaceWinninghand.Color">
            {{ 'Color' | translate }} : {{CardRaceWinninghand.Color? translateService.instant(CardRaceWinninghand.Color) : ''}}
          </div>
        </div>
        <!--  Card Race Cards End -->
        <!-- Virtual  Black Jack Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'BJ'">
          <div class="playera text-center">
            <h6>{{ 'Player' | translate }} <span class="score"
                [ngClass]="MarketHistoryDetails.PlayerAScore>MarketHistoryDetails.PlayerBScore?'green':'red'">{{MarketHistoryDetails.PlayerAScore}}</span>
            </h6>
            <div class="mhistorycard flipcard h">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[2]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerACard[0]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Player'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Delaer'">
              {{ 'Loser' | translate }}</div>
          </div>
          <br>
          <div class="playerb text-center">
            <h6>{{ 'Dealer' | translate }} <span class="score"
                [ngClass]="MarketHistoryDetails.PlayerBScore>MarketHistoryDetails.PlayerAScore?'green':'red'">{{MarketHistoryDetails.PlayerBScore}}</span>
            </h6>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[0]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h ">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[1]]}}"> </div>
            </div>
            <div class="mhistorycard flipcard h">
              <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
              <div class="back"><img class="casinocard"
                  src="{{constant.CardImages[MarketHistoryDetails.PlayerBCard[2]]}}"> </div>
            </div>
            <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Delaer'">
              {{ 'Winner' | translate }}</div>
            <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Player'">
              {{ 'Loser' | translate }}</div>
          </div>
          <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Tie'">
            <br>{{ 'Tie' | translate }}
          </div>
        </div>
        <!-- Virtual Black Jack Cards End -->
        <!-- Virtual Rock Paper Scissior Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'VRPS' && selectedGameCode != 'RPS'">
          <div class="playera row text-center" style="text-align: center;">
            <div class="col-sm-6 ">
              <h6>{{ 'Silver' | translate }} </h6>
              <div class="mhistorycard flipcard h ">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.SilverCard[0]]}}"> </div>
              </div>
              <!-- <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Dragon'">{{ 'Winner' | translate }}</div>
      <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Tiger'">{{ 'Loser' | translate }}</div> -->
            </div>
            <div class="col-sm-6">
              <h6>{{ 'Gold' | translate }} </h6>
              <div class="mhistorycard flipcard h ">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.GoldCard[0]]}}"> </div>
              </div>
              <!-- <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='Tiger'">{{ 'Winner' | translate }}</div>
      <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='Dragon'">{{ 'Loser' | translate }}</div> -->
            </div>
          </div>
          <br>
          <div class="game-result winner-hand " *ngIf="rockPaperScissors.Winner.Silver">
            {{ 'Silver' | translate }} : {{rockPaperScissors.Winner.Silver? translateService.instant(rockPaperScissors.Winner.Silver) : ''}}
          </div>
          <div class="game-result winner-hand" *ngIf="rockPaperScissors.Winner.Gold">
            {{ 'Gold' | translate }} : {{rockPaperScissors.Winner.Gold? translateService.instant(rockPaperScissors.Winner.Gold) : ''}}
          </div>
        </div>
        <!-- Virtual Rock Paper Scissior Cards End -->
        <!-- Super Over Result Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'SO' && selectedGameCode != 'RSO'"
          style="max-width: 500px;margin: auto!important;">
          <div class="playera row text-center" style="text-align: center;">
            <div class="col-xs-12 m-0">
              <h5 class="team-head">
                <b>{{ 'TeamA' | translate }}</b>
                <span>
                  {{MarketHistoryDetails.TeamA.Score}}/{{MarketHistoryDetails.TeamA.Wicket}}
                  ({{MarketHistoryDetails.TeamA.Over}})
                </span>
              </h5>
              <div class="clearfix"></div>
              <div class="col-xs-12 p-0 m-0">
                <div class="col-xs-4 col-md-2 col-sm-2 p-0 float-left"
                  *ngFor="let Ball of MarketHistoryDetails.TeamA.Run;let index = index;">
                  <span class="ball">
                    <span>{{Ball}}</span>
                  </span>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="clearfix"></div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='TeamA'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='TeamB'">
                {{ 'Loser' | translate }}</div>
              <div class="clearfix"></div>
              <h5 class="team-head">
                <b>{{ 'TeamB' | translate }}</b>
                <span>
                  {{MarketHistoryDetails.TeamB.Score}}/{{MarketHistoryDetails.TeamB.Wicket}}
                  ({{MarketHistoryDetails.TeamB.Over}})
                </span>
              </h5>
              <div class="clearfix"></div>
              <div class="col-xs-12 p-0 m-0">
                <div class="col-xs-4 col-md-2 col-sm-2 p-0 float-left"
                  *ngFor="let Ball of MarketHistoryDetails.TeamB.Run;let index = index;">
                  <span class="ball">
                    <span>{{Ball}}</span>
                  </span>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="clearfix"></div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner=='TeamB'">
                {{ 'Winner' | translate }}</div>
              <div class="game-result loss" *ngIf="MarketHistoryDetails.Winner=='TeamA'">
                {{ 'Loser' | translate }}</div>
              <div class="game-result draw" *ngIf="MarketHistoryDetails.Winner=='Tie'">
                <br>{{ 'Tie' | translate }}
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="teama-whand" *ngIf="SOWinningHand.TeamA != null && SOWinningHand.TeamA.length">
              <p class="text-center" style="margin-bottom: 0;font-weight: bold;">{{ 'TeamA' | translate}}
              </p>
              <span *ngFor="let item of SOWinningHand.TeamA;let index = index;">{{item.Run}}</span>
            </div>
            <div class="teamb-whand" *ngIf="SOWinningHand.TeamB != null && SOWinningHand.TeamB.length">
              <p class="text-center" style="margin-bottom: 0;font-weight: bold;">{{ 'TeamB' | translate}}
              </p>
              <span *ngFor="let item of SOWinningHand.TeamB;let index = index;">{{item.Run}}</span>
            </div>
            <div class="game-result draw" *ngIf="SOWinningHand.Common_Boundry">
              <br>{{ 'Common Boundry' | translate}}
            </div>
            <div class="game-result draw" *ngIf="SOWinningHand.Common_Wicket">
              <br>{{ 'Common Wicket' | translate }}
            </div>
          </div>
        </div>
        <!-- Super Over Result End -->
        <!-- Cricket 20-20 Result Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'CKT20' && selectedGameCode != 'RCKT20'"
          style="max-width: 500px;margin: auto!important;">
          <div class="playera row text-center" style="text-align: center;">
            <div class="col-xs-12 m-0">
              <div class="mhistorycard flipcard h " style="margin-bottom: 20px;">
                <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                <div class="back"><img class="casinocard"
                    src="{{constant.CardImages[MarketHistoryDetails.CKT20.Card]}}"> </div>
              </div>
            </div>
            <div class="col-xs-12 m-0">
              <h5 class="team-head">
                <b>T{{ 'TeamA' | translate}}</b>&nbsp;&nbsp;&nbsp;
                {{MarketHistoryDetails.CKT20.TeamA.Run}}/{{MarketHistoryDetails.CKT20.TeamA.Wicket}}
                ({{MarketHistoryDetails.CKT20.TeamA.Over}})
              </h5>
              <div class="clearfix"></div>
              <h5 class="team-head">
                <b>{{ 'TeamB' | translate}}</b>&nbsp;&nbsp;&nbsp;
                {{MarketHistoryDetails.CKT20.TeamB.Run}}/{{MarketHistoryDetails.CKT20.TeamB.Wicket}}
                ({{MarketHistoryDetails.CKT20.TeamB.Over}})
              </h5>
              <div class="clearfix"></div>
              <div class="game-result win" *ngIf="MarketHistoryDetails.Winner != ''">
                <br>{{ 'Winner' | translate}} {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}} {{ 'Run' | translate}}
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div class="game-result winner-hand-popup">{{MarketHistoryDetails.WinningHand ? translateService.instant(MarketHistoryDetails.WinningHand) : ''}}</div>
            <div class="clearfix"></div>
          </div>
        </div>
        <!-- Cricket 20-20 Result End -->
        <!-- Casino Queen Card Start -->
        <div class="player-cards andar-bahar"
          [hidden]="selectedGameCode != 'CQ' && selectedGameCode != 'RCQ' && selectedGameCode != 'CQ20' && selectedGameCode != 'RCQ20'"
          style="max-width: 430px;">
          <div class="player-cont row m-0" style="padding-top: 10px;text-align: center;">
            <div class="col-md-6 col-sm-6 col-xs-6" style="text-align: center;">
              <ngx-slick-carousel class="carousel carouselm-a carousel-modal" id="slickAModal"
                #slickAModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem class="slide card-width"
                  *ngFor="let card of MarketHistoryDetails.Player0.Cards;trackBy: trackByFn;let index = index;let count = count;">
                  <div class="livecard flipcard h flip">
                    <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                    <div class="back" [class.disabled]="count - 1 != index"> <img class="casinocard"
                        src="{{constant.CardImages[card]}}"></div>
                  </div>
                </div>
              </ngx-slick-carousel>
              <h6 style="padding-top: 10px;">{{ 'Player0' | translate }} <span
                  style="background: red;border-radius: 50%;font-weight: bold;padding: 0px 7px 0px 5px;">{{MarketHistoryDetails.Player0.Score}}</span>
              </h6>
            </div>

            <div class="col-md-6 col-sm-3 col-xs-6" style="text-align: center;">
              <ngx-slick-carousel class="carousel carouselm-b carousel-modal" id="slickAModal"
                #slickAModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem class="slide card-width"
                  *ngFor="let card of MarketHistoryDetails.Player1.Cards;trackBy: trackByFn;let index = index;let count = count;">
                  <div class="livecard flipcard h flip">
                    <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                    <div class="back" [class.disabled]="count - 1 != index"> <img class="casinocard"
                        src="{{constant.CardImages[card]}}"></div>
                  </div>
                </div>
              </ngx-slick-carousel>
              <h6 style="padding-top: 10px;">{{ 'Player1' | translate }}
                <span
                  style="background: red;border-radius: 50%;font-weight: bold;padding: 0px 7px 0px 5px;">{{MarketHistoryDetails.Player1.Score}}</span>
              </h6>
            </div>

            <div class="col-md-6 col-sm-3 col-xs-6" style="text-align: center;">
              <ngx-slick-carousel class="carousel carouselm-c carousel-modal" id="slickAModal"
                #slickAModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem class="slide card-width"
                  *ngFor="let card of MarketHistoryDetails.Player2.Cards;trackBy: trackByFn;let index = index;let count = count;">
                  <div class="livecard flipcard h flip">
                    <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                    <div class="back" [class.disabled]="count - 1 != index"> <img class="casinocard"
                        src="{{constant.CardImages[card]}}"></div>
                  </div>
                </div>
              </ngx-slick-carousel>
              <h6 style="padding-top: 10px;">{{ 'Player2' | translate }}
                <span
                  style="background: red;border-radius: 50%;font-weight: bold;padding: 0px 7px 0px 5px;">{{MarketHistoryDetails.Player2.Score}}</span>
              </h6>
            </div>

            <div class="col-md-6 col-sm-3 col-xs-6" style="text-align: center;">
              <ngx-slick-carousel class="carousel carouselm-d carousel-modal" id="slickModal"
                #slickModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem class="slide card-width"
                  *ngFor="let card of MarketHistoryDetails.Player3.Cards;trackBy: trackByFn;let index = index;let count = count;">
                  <div class="livecard flipcard h flip">
                    <div class="front"><img src="{{constant.CardImages['Back']}}"></div>
                    <div class="back" [class.disabled]="count - 1 != index"> <img class="casinocard"
                        src="{{constant.CardImages[card]}}"></div>
                  </div>
                </div>
              </ngx-slick-carousel>
              <h6 style="padding-top: 10px;">{{ 'Player3' | translate }}
                <span
                  style="background: red;border-radius: 50%;font-weight: bold;padding: 0px 7px 0px 5px;">{{MarketHistoryDetails.Player3.Score}}</span>
              </h6>
            </div>

          </div>
          <div class="game-result m-0 row win" style="justify-content: space-around;">
            {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}</div>
          <div class="game-result winner-hand-popup">{{MarketHistoryDetails.WinningHand ? translateService.instant(MarketHistoryDetails.WinningHand) : ''}}</div>
        </div>
        <!-- 7. Akbar Romeo Walter Cards Start -->
        <div class="player-cards" [hidden]="selectedGameCode != 'WH' && selectedGameCode != 'RT'">
          <div class="text-center">
            <div class="winner-number">
              {{MarketHistoryDetails.Winner ? translateService.instant(MarketHistoryDetails.Winner) : ''}}
            </div>
            <div class="game-result winner-hand-popup">
              <span>{{ 'Color' | translate }}: <span class="hand-value"
                  *ngIf="WheelWinninHand.Color">{{WheelWinninHand.Color? translateService.instant(WheelWinninHand.Color) : ''}}</span></span>
              <br><span>{{ 'Hand' | translate }}: <span class="hand-value"
                  *ngIf="WheelWinninHand.Hand">{{WheelWinninHand.Hand? translateService.instant(WheelWinninHand.Hand) : ''}}</span></span>
              <br><span>{{ 'ThreeRunner' | translate }}:<span
                  class="hand-value">{{WheelWinninHand.ThreeRunner? translateService.instant(WheelWinninHand.ThreeRunner) : ''}}</span></span>
              <br><span>{{ 'SixRunner' | translate }}: <span
                  class="hand-value">{{WheelWinninHand.SixRunner? translateService.instant(WheelWinninHand.SixRunner) : ''}}</span></span>
              <br><span>{{ 'TwelveRunner' | translate }}: <span
                  class="hand-value">{{WheelWinninHand.TwelveRunner? translateService.instant(WheelWinninHand.TwelveRunner) : ''}}</span></span>
              <br><span>{{ 'EighteenRunner' | translate }}: <span
                  class="hand-value">{{WheelWinninHand.EighteenRunner? translateService.instant(WheelWinninHand.EighteenRunner) : ''}}</span></span>
              <br><span>{{ 'RowRunner' | translate }}: <span
                  class="hand-value">{{WheelWinninHand.RowRunner? translateService.instant(WheelWinninHand.RowRunner) : ''}}</span></span>
            </div>
          </div>
        </div>
        <!-- Akbar Romeo Walter Cards End -->
        <br>
        <div style="overflow-x: auto;">
          <table class="table table-bordered table-placebet table-betview noMarginBottom">
            <thead>
              <tr class="clsBackTr">
                <th class="text-center">{{ 'RefID' | translate }}</th>
                <th class="text-center">{{ 'Date' | translate }} </th> <!-- M.Date -->
                <th class="text-center">{{ 'Runner' | translate }}</th>
                <th class="text-center" *ngIf="selectedGameCode == 'WM' || selectedGameCode == 'VWM' || selectedGameCode == 'V3CJ' || selectedGameCode == 'D3CJ'
        || selectedGameCode == 'VJKR' || selectedGameCode == 'JKR' || selectedGameCode == 'WH' || selectedGameCode == 'RT'">
                  {{ 'Number' | translate }}
                </th>
                <th class="text-center">{{ 'Odds'  | translate }} </th>
                <th class="text-center">{{ 'Stake' | translate }} </th>
                <th class="text-center">{{ 'ProfitLoss' | translate }}</th>
                <th class="text-center">{{ 'Dr' | translate }} </th>
                <th class="text-center">{{ 'Cr' | translate }} </th>
                <th class="text-center">{{ 'Net' | translate }} </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of MarketHistoryDetails.BetList" class="color-black tr"
                [ngClass]="item.IsBack?'back-rate-gridcolor':'lay-rate-gridcolor'" style="color:black;">
                <td class="text-center">
                  <span>{{item.BetID}}</span>
                </td>
                <td class="text-center">
                  <span>{{constant.utcToLocal(item.CreatedDate) | date : 'dd-MM-yyyy'}}</span>
                </td>
                <td class="text-center">
                  <span>{{RunnerName(item.Runner.trim())}}</span>
                </td>
                <td class="text-center" *ngIf="selectedGameCode == 'WM' || selectedGameCode == 'VWM'">
                  <span>{{item.Number == 0 && item.Runner.trim()=='TP' ? 'All' : item.Number}}</span>
                </td>
                <td class="text-center" *ngIf="selectedGameCode == 'VJKR' || selectedGameCode == 'JKR'">
                  <span>{{JokerNumber(item.Number)}}</span>
                </td>
                <td class="text-center" *ngIf="selectedGameCode == 'WH' || selectedGameCode == 'RT'">
                  <span>{{WheelRTNumber(item.Runner.trim(),item.Number)}}</span>
                </td>
                <td class="text-center" *ngIf="selectedGameCode == 'V3CJ'">
                  <span>{{cardNumberToString(item.Number)}}</span>
                </td>
                <!-- <td class="text-center">
                  <span>{{item.Rate | number:'1.2-2'}}</span>
                </td> -->
                <td class="text-center">
                  <span>{{ (item.Runner.trim() === 'Red' || item.Runner.trim() === 'Green') ? ('1.5/ ' + (item.Rate | number:'1.2-2') + "") : (item.Rate | number:'1.2-2') }}</span>
                </td>
                <td class="text-right">
                  <span>{{item.Stake | number:'1.2-2'}}</span>
                </td>
                <td class="text-right">
                  <span>{{item.BetPL |
                    number:'1.2-2'}}</span>
                </td>
                <td class="text-right">
                  <span>{{item.IsBetWon==0?item.BetPL:00.0 | number:'1.2-2'}}</span>
                </td>
                <!-- <td class="text-right">
                  <span>{{item.IsBetWon==0?-item.BetPL:00.0 | number:'1.2-2'}}</span>
                </td> -->
                <td class="text-right">
                  <span>{{item.IsBetWon==1?item.BetPL:00.0 | number:'1.2-2'}}</span>
                </td>
                <td class="text-right">
                  <span>{{ item.Net |
                    number:'1.2-2'}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-body" [hidden]="PopupLoader !== true">
        <div class="PopupLoader">
          <div class="ripple" style="filter:grayscale()"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Market History Details Pop Up End -->